import React from 'react';
import {ListContent, getListContentClass, processTranslation, processTranslationReplaceAll} from '../utils/commonUtil';

const getListContent = (translations, userType, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility) => {
    let contents;

    switch (userType) {
        case 'IPM_SOFTWARE_SWITCH':
            contents = [];
            contents.push(processTranslation(translations['ipmob.ppm.complete.dialog.list.content_1'], [brandName]));
            contents.push(processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]));
            contents.push(translations['ipmob.ppm.complete.dialog.list.content_3']);

            // if (isSWSv2FlowEnabled) {
            //     const removeDecommissionRelatedKeys = [processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]), translations['ipmob.ppm.complete.dialog.list.content_3']];
            //     contents = contents.filter(item => !removeDecommissionRelatedKeys.includes(item));
            // }
            break;
        case 'PPM':
            contents = [];
            contents.push(processTranslation(translations['ipmob.ppm.complete.dialog.list.content_1'], [brandName]));
            contents.push(processTranslationReplaceAll(translations['ipmob.ppm.complete.dialog.list.content_2'], [brandName]));
            contents.push(translations['ipmob.ppm.complete.dialog.list.content_3']);
            break;
        case 'IPM':
        default:
            contents = [];
            contents.push(translations['ipmob.complete.dialog.list.content.4']);
            contents.push(processTranslation(translations['ipmob.complete.dialog.list.content.1'], [brandName]));
            contents.push(translations['ipmob.complete.dialog.list.content.3']);
            break;
    }
    if (gqlEligibility) {
        contents.push("You are eligible for GQL service");
    }
    return contents;
};

const getCompletePageContent = (userType, translations, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility) => {
    const contentList = getListContent(translations, userType, brandName, isSWSv2FlowEnabled, siteName, gqlEligibility);
    const listItemClass = getListContentClass(userType);

    return (
        <div className="complete-page-content">
            <ListContent
                contentList={contentList}
                listItemClass={listItemClass}
            />
        </div>
    );
};

const getCompletePageContentsForBMXFlow = (translations) => {
    return (
        <div className="complete-page-content">
                <p>
                    <strong>{translations['ipmob.complete.bmx.heading_1']}</strong>
                </p>
                <ul>
                    <li>
                        <p>
                            <span>
                                {translations['ipmob.complete.bmx.list_1']}
                            </span>
                        </p>
                    </li>
                    <li>
                        <p>
                            {translations['ipmob.complete.bmx.list_2']}
                        </p>
                    </li>
                </ul>
                <p>
                    <span>
                        <strong>{translations['ipmob.complete.bmx.heading_2']}</strong>
                    </span>
                </p>
                <p>
                    <span>
                        {translations['ipmob.complete.bmx.paragraph_1']}
                    </span>
                </p>
                <div style={{ height: '50px' }} />
            </div>
        );
    }

const getCompletePageContents = (gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, gqlStatus, userType) => {
    let completePageContents;
    switch (gqlUserType) {
        case 'PPM':
        case 'IPM_SOFTWARE_SWITCH':
            completePageContents = {
                heading: translations['ipmob.ppm.complete.heading'],
                dialogHeading: processTranslation(translations['ipmob.ppm.complete.dialog.heading'], [brandName]),
                contents: getCompletePageContent(gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, false),
                dialogFooter: translations['ipmob.ppm.complete.dialog.footer']
            };
            break;

        case 'IPM':
        default:
            completePageContents = {
                heading: translations['ipmob.complete.heading'],
                dialogHeading: translations['ipmob.complete.dialog.heading'],
                contents: getCompletePageContent(gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, false),
                dialogFooter: translations['ipmob.complete.dialog.footer']
            };
            break;
    }
    if(gqlStatus) {
        const completePageContent = getCompletePageContent(gqlUserType, translations, brandName, isSWSv2FlowEnabled, siteName, true);
        completePageContents = {
            heading: translations['ipmob.complete.heading'],
            dialogHeading: translations['ipmob.complete.dialog.heading'],
            contents: completePageContent,
            dialogFooter: translations['ipmob.complete.dialog.footer']
        };
    }
    if (userType === 'BMX_IPM') {
        completePageContents.heading = translations['ipmob.complete.bmx.main_heading'];
        completePageContents.dialogHeading = "";
        completePageContents.contents = getCompletePageContentsForBMXFlow(translations);
        completePageContents.dialogFooter = "";
        completePageContents.actionLabel = translations['ipmob.complete.bmx.button.label'];
    }
    return completePageContents;
};

export {getCompletePageContents};
